export const carouselData = [
  {
    id: 1,
    name: "toasted bread",
    //url:"https://i.ibb.co/mN6K9rY/samscarouseltoastedbread.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouseltoastedbread.jpg?updatedAt=1714660184970,w-500,q-80,f-webp`,
    description: "good product",
    price: "500",
  },
  {
    id: 2,
    name: "Pan cake",
    //url: "https://i.ibb.co/vVRbDPF/samscarouselpancake-1.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouselpancake%20(1).jpg?updatedAt=1714660175581,w-500,q-80,f-webp`,
    description: "good product",
    price: "650",
  },
  {
    id: 3,
    name: "Iyan",
    //url: "https://i.ibb.co/BwPgkq5/samscarouseliyan.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouseliyan.jpg?updatedAt=1714660146061,w-500,q-80,f-webp`,
    description: "good product",
    price: "1500",
  },
  {
    id: 4,
    name: "Egusi and meat",
    //url: "https://i.ibb.co/6B6RD7r/samscarouselegusi.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouselegusi.jpg?updatedAt=1714660133582,w-500,q-80,f-webp`,
    description: "good product",
    price: "1000",
  },
  {
    id: 5,
    name: "Eba and soup",
    //url: "https://i.ibb.co/XxwNLxH/samscarouseleba-1.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouseleba%20(1).jpg?updatedAt=1714660104939,w-500,q-80,f-webp`,
    description: "good product",
    price: "800",
  },
  {
    id: 6,
    name: "Cake",
    //url: "https://i.ibb.co/GHXwY9H/samscarouselcake.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouselcake.jpg?updatedAt=1714660409533,w-500,q-80,f-webp`,
    description: "good product",
    price: "1500",
  },
  {
    id: 7,
    name: "Akara and bread",
    //url: "https://i.ibb.co/bzLnDBw/samscarouselbread.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouselbread.jpg?updatedAt=1714660060739,w-500,q-80,f-webp`,
    description: "good product",
    price: "1000",
  },
  {
    id: 8,
    name: "Sams doughnut",
    //url: "https://i.ibb.co/JCD0Njb/samscarouseldoughnut.jpg",
    url: `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT}/samsCarousel/samscarouseldoughnut.jpg?updatedAt=1714660088114,w-500,q-80,f-webp`,
    description: "good product",
    price: "1200",
  },
];
